<template>
  <v-app class="bgLightGreen boiler-page" id="inspire">
    <!-- <Header back header-text="Heating"></Header> -->
    <v-toolbar color="primary" app>
      <v-btn flat color="white" @click="returnToPreviousPage()">
        <v-icon large>keyboard_arrow_left</v-icon>
      </v-btn>
      <h2 class="title white--text font-weight-regular">
        {{ "Heating" | translate }}
      </h2>
      <v-btn color="white">Login</v-btn>
    </v-toolbar>
    <v-container fluid style="display: flex;">
      <v-layout row wrap justify-center style="margin: auto;">
        <v-flex xs12 sm3 md2 class="px-4 panel-block" >
          <div class="fieldset mt-4">
            <!-- <legend class="md-whiteframe-z2" align="center">
              {{ "zone1" | translate }}
            </legend> -->

            <div class="name-container">
              <span v-if="!editNameToggle">{{ zone1Name }}</span>
              <v-text-field
                v-else
                ref="nameField"
                v-model="zone1Name"
                @blur="editNameToggle=false"
              ></v-text-field>
              <v-icon small style="cursor: pointer;" @click="editName">edit</v-icon>
            </div>

            <v-flex style="text-align: -webkit-center;">
              <v-icon small color="orange">whatshot</v-icon>
              <vue-slider
                :processStyle="vueSliderColor"
                v-model="tempVal"
                height="200px"
                direction="btt"
                :min="0"
                :max="1"
                :value="tempVal"
                :interval="0.01"
                @change="(value, index) => detactSliderChange(value, index)"
                :lazy="true"
              />
              <v-icon small color="blue">ac_unit</v-icon>
            </v-flex>
          </div>
        </v-flex>
        <v-flex xs12 sm3 md2 class="px-4 panel-block" >
          <div class="fieldset mt-4">
            <div class="name-container">
              <span v-if="!editNameToggle">{{ zone1Name }}</span>
              <v-text-field
                v-else
                v-model="zone1Name"
                @blur="editNameToggle=false"
              ></v-text-field>
              <v-icon small style="cursor: pointer;" @click="editNameToggle=true">edit</v-icon>
            </div>
            <v-flex style="text-align: -webkit-center;">
              <v-icon small color="orange">whatshot</v-icon>
              <vue-slider
                :processStyle="vueSliderColor"
                v-model="tempVal"
                height="200px"
                direction="btt"
                :min="0"
                :max="1"
                :value="tempVal"
                :interval="0.01"
              />
              <v-icon small color="blue">ac_unit</v-icon>
            </v-flex>
          </div>
        </v-flex>
        <v-flex xs12 sm3 md2 class="px-4 panel-block" >
          <div class="fieldset mt-4">
            <div class="name-container">
              <span v-if="!editNameToggle">{{ zone1Name }}</span>
              <v-text-field
                v-else
                v-model="zone1Name"
                @blur="editNameToggle=false"
              ></v-text-field>
              <v-icon small style="cursor: pointer;" @click="editNameToggle=true">edit</v-icon>
            </div>
            <v-flex style="text-align: -webkit-center;">
              <v-icon small color="orange">whatshot</v-icon>
              <vue-slider
                :processStyle="vueSliderColor"
                v-model="tempVal"
                height="200px"
                direction="btt"
                :min="0"
                :max="1"
                :value="tempVal"
                :interval="0.01"
              />
              <v-icon small color="blue">ac_unit</v-icon>
            </v-flex>
          </div>
        </v-flex>
        <v-flex xs12 sm3 md2 class="px-4 panel-block" >
          <div class="fieldset mt-4">
            <div class="name-container">
              <span v-if="!editNameToggle">{{ zone1Name }}</span>
              <v-text-field
                v-else
                v-model="zone1Name"
                @blur="editNameToggle=false"
              ></v-text-field>
              <v-icon small style="cursor: pointer;" @click="editNameToggle=true">edit</v-icon>
            </div>
            <v-flex style="text-align: -webkit-center;">
              <v-icon small color="orange">whatshot</v-icon>
              <vue-slider
                :processStyle="vueSliderColor"
                v-model="tempVal"
                height="200px"
                direction="btt"
                :min="0"
                :max="1"
                :value="tempVal"
                :interval="0.01"
              />
              <v-icon small color="blue">ac_unit</v-icon>
            </v-flex>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
    <v-dialog v-model="dialog" @input="v => v || closeDialog()" max-width="688px">
      <v-card>
        <v-card-title>Time Duration for Changed Temperature</v-card-title>
        <v-card-text>
          <v-layout row wrap justify-center>
            <v-flex xs12 sm8 md8 class="my-3">
              <v-select
                :items="items"
                label="Select Time Duration"
              ></v-select>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-layout row wrap justify-center>
            <v-flex xs7 class="pr-2">
              <v-btn block flat @click="closeDialog" class="close-btn">{{
                "lng_ok" | translate
              }}</v-btn>
            </v-flex>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
import Header from "../components/Header";
import Menu from "../components/menus/Menu";
import GlobalService from "../services/global-service";
import FlashMessage from "../components/FlashMessage";
import { translate } from "../common/HelperFunctions";
import router from "../router";
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/antd.css'

export default {
  //component to add "Header", "Submenues", "Refresh page timer" and "boiler menu"
  components: {
    Header,
    appMenu: Menu,
    FlashMessage,
    VueSlider
  },
  data: () => ({
    alertToggle: false,
    flashMessageData: {},
    responseObj: {},
    pageRefreshTime: 30,
    timerKey: 0,
    showTimer: false,
    tempVal: "0.45",
    sliderColor: { backgroundColor: "pink" },
    items: ['forever', '1 hour', '2 hour', '3 hour', '4 hour', '5 hour', '6 hour', '7 hour', '8 hour', '9 hour', '10 hour', '11 hour', '12 hour',
    '13 hour', '14 hour', '15 hour', '16 hour', '17 hour', '18 hour', '19 hour', '20 hour', '21 hour', '22 hour', '23 hour', '24 hour'],
    dialog: false,
    editNameToggle: false,
    zone1Name: "zone1",
  }),
  async created() {
    // start page loading component
    // this.$store.commit("global/setLoading", true);
    // await this.FetchApisData();
  },
  mounted() {
    document.getElementsByTagName("html")[0].className = "";
    console.log("ksdkk", this.$route)
  },
  computed: {
    ...mapGetters("user", ["getUser"]),
    color () {
      if (this.tempVal < 0.25) return 'indigo'
      if (this.tempVal < 0.50) return 'teal'
      if (this.tempVal < 0.75) return 'green'
      if (this.tempVal < 1) return 'orange'
      return 'red'
    },
    vueSliderColor() {
      if (this.tempVal < 0.25) return { backgroundColor: "deepskyblue"}
      if (this.tempVal < 0.50) return { backgroundColor: "deepskyblue"}
      if (this.tempVal < 0.75) return { backgroundColor: "orange"}
      if (this.tempVal < 1) return { backgroundColor: "orange"}
      return { backgroundColor: "red"}
    }
  },
  methods: {
    editName(){
      this.editNameToggle = true;
      setTimeout(() => {
        this.$refs.nameField.focus();
      }, 500);
      
    },
    // fetch api's data needed in boiler's page
    async FetchApisData() {
      await GlobalService.getMenu(
        "boiler",
        this.getUser.token
      );
      this.$store.commit("global/setLoading", false);
    },
    // to show the resposne alert on update field
    setResponseAlert(resObj) {
      this.alertToggle = true;
      this.responseObj = resObj;
      this.flashMessageData = {
        saved: resObj.onlineandsaved ? "lng_save_ok" : "lng_save_notok",
        messageText: resObj.onlineandsaved
          ? `${translate("lng_save_ok")}`
          : `${translate("lng_save_notok")}`,
        showRegisterButton: false,
        color: resObj.onlineandsaved ? "rgba(76, 175, 80, 0.9)" : "red"
      };
      if (resObj.secs_to_next_update > 0) {
        this.pageRefreshTime = resObj.secs_to_next_update;
      }
      this.timerKey += 1;
    },
    flashMessageTimeOut() {
      this.alertToggle = false;
      this.responseObj = {};
    },
    // a funtion to refresh the page after specific time
    async refreshPage() {
      await this.FetchApisData();
      this.pageRefreshTime = 30;
      this.timerKey += 1;
    },
    openTimerPage() {
      router.push("/boiler/boiler-timer");
    },
    detactSliderChange(value, index){
      this.dialog = true;
      console.log(this.tempVal);
    },
    closeDialog(){
      this.dialog = false;
    }
  }
};
</script>

<style scoped>
  .fieldset {
    margin: 0 0 20px;
    padding-top: 5px;
    padding-left: 5px;
    padding-right: 5px;
    border-radius: 10px;
    border: 2px solid #455a64;
    background: rgba(255, 255, 255, 0.3);
  }
  .fieldset .name-container {
    display: flex; 
    align-items: center; 
    justify-content: space-between;
    margin-bottom: 10px;
    height: 30px;
  }
  .v-toolbar__content {
    justify-content: space-between;
  }
</style>